export const download = (
    uuid = ':uuid'
) => `/files/${uuid}`;
